import { StorageAccountV1 } from 'mbs-ui-shared@models/StorageAccount';
import { StorageConnection } from 'mbs-ui-shared@models/storge-connections';

export const storageAccountsToDestinationsArray = (storageAccounts: StorageAccountV1[]): StorageConnection[] => {
  return storageAccounts.reduce((acc, account: StorageAccountV1) => {
    const newBuckets = account.buckets.map((bucket) => {
      return {
        DisplayName: `${bucket.destinationName} (${bucket.bucketName})`,
        DestinationName: bucket.destinationName,
        IsLocal: account.isLocal,
        ID: bucket.id,
        ImmutabilityMode: bucket.immutabilityMode,
        MinimumStorageDuration: account.MinimumStorageDuration,
        Region: bucket.regionDisplayName || 'N/A',
        // Capability checks read it off the connection — without it an FFI-capable storage loses the Simple schedule
        S3CompatibleSynthetic: account.S3CompatibleSynthetic,
        StorageType: account.storageType,
        StorageUsage: bucket.storageUsage,
        Bucket: bucket.bucketName,
        BucketId: bucket.bucketId,
        StorageAccountName: account.name,
        StorageAccountType: account.storageType
      };
    });
    acc.push(...newBuckets);

    return acc;
  }, []);
};
